// Conversation Channels - must match the backend enum values
export const ConversationChannel = {
  WHATSAPP_TWILIO: 'whatsapp::twilio',
  WHATSAPP_WABA: 'whatsapp::waba',
  SMS: 'sms',
  EMAIL: 'email',
  VOICE: 'voice',
  WEBCHAT: 'webchat'
};

// Template Types - must match the backend enum values
export const NexiGlobalTemplateType = {
  INTERNAL: 'internal',
  WHATSAPP_TEMPLATE: 'whatsapp_template',
  WHATSAPP_LIST: 'whatsapp_list',
  WHATSAPP_QUICK_REPLY: 'whatsapp_quick_reply',
  AGENT_TOOL_REPLY: 'agent_tool_reply'
};

// Language Codes - must match the backend enum values (libs/nexi_core/models/language_code.py)
export const LanguageCode = {
  EN_US: 'en_US',
  ZH_CN: 'zh_CN',
  ZH_HK: 'zh_HK',
  TA_IN: 'ta_IN',
  MS_MY: 'ms_MY',
  JA_JP: 'ja_JP'
};

// Options for supported locales (value + label), matches LANGUAGE_CODE_OPTIONS in language_code.py
export const SUPPORTED_LOCALE_OPTIONS = [
  { value: 'en_US', label: 'English' },
  { value: 'zh_HK', label: 'Chinese (Traditional)' },
  { value: 'zh_CN', label: 'Chinese (Simplified)' },
  { value: 'ja_JP', label: 'Japanese' },
  { value: 'ta_IN', label: 'Tamil' },
  { value: 'ms_MY', label: 'Malay' }
];
